// import React, { useRef, useState } from "react";
// import "./Payslip.css";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import {
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableRow,
//   Paper,
//   TableContainer,
//   FormControl,
//   Select,
//   MenuItem,
//   InputLabel,
//   Divider,
// } from "@mui/material";
// import logo from "../../.././assets/images/Picture2.png";

// const PaySlipTab = () => {
//   const pdfRef = useRef();
//   const [year, setYear] = useState("2024");
//   const [month, setMonth] = useState("January");

//   const downloadPDF = async () => {
//     const canvas = await html2canvas(pdfRef.current, { scale: 2 });
//     const imgData = canvas.toDataURL("image/png");

//     const pdf = new jsPDF("p", "mm", "a4");
//     const imgWidth = 190;
//     const imgHeight = (canvas.height * imgWidth) / canvas.width;

//     pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
//     pdf.save(`Payslip_${month}_${year}.pdf`);
//   };

//   return (
//     <>
//       {/* FILTER BAR */}
//       <div className="payslip-filter">
//   {/* YEAR SELECT */}
//   <FormControl size="small" className="filter-control">
//     <InputLabel id="year-label">Select Year</InputLabel>
//     <Select
//       labelId="year-label"
//       label="Select Year"
//       value={year}
//       onChange={(e) => setYear(e.target.value)}
//     >
//       {[2020, 2021, 2022, 2023, 2024, 2025, 2026].map((yr) => (
//         <MenuItem key={yr} value={yr}>
//           {yr}
//         </MenuItem>
//       ))}
//     </Select>
//   </FormControl>

//   {/* MONTH SELECT */}
//   <FormControl size="small" className="filter-control">
//     <InputLabel id="month-label">Select Month</InputLabel>
//     <Select
//       labelId="month-label"
//       label="Select Month"
//       value={month}
//       onChange={(e) => setMonth(e.target.value)}
//     >
//       {[
//         "January",
//         "February",
//         "March",
//         "April",
//         "May",
//         "June",
//         "July",
//         "August",
//         "September",
//         "October",
//         "November",
//         "December",
//       ].map((mon) => (
//         <MenuItem key={mon} value={mon}>
//           {mon}
//         </MenuItem>
//       ))}
//     </Select>
//   </FormControl>
// </div>


//       {/* PAYSLIP CARD */}
//       <Card ref={pdfRef} className="payslip-wrapper">
//         {/* HEADER */}
//         <div className="payslip-header">
//           <img src={logo} alt="company-logo" />
//           <div>
//             <h2>Envision Integrated Services Pvt. Ltd.</h2>
//             <p>CIN: U72200TG201PTC0903</p>
//             <p>Bengaluru, Karnataka</p>
//           </div>
//         </div>

//         <Divider />

//         <Typography className="payslip-title">
//           PAY SLIP – {month.toUpperCase()} {year}
//         </Typography>

//         {/* EMPLOYEE DETAILS */}
//         <TableContainer component={Paper} className="table-box">
//           <Table size="small">
//             <TableBody>
//               <TableRow>
//                 <TableCell><b>Employee Name</b></TableCell>
//                 <TableCell>Jon Doe</TableCell>
//                 <TableCell><b>Employee ID</b></TableCell>
//                 <TableCell>ENV-1021</TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell><b>Designation</b></TableCell>
//                 <TableCell>Finance Manager</TableCell>
//                 <TableCell><b>Department</b></TableCell>
//                 <TableCell>Finance</TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell><b>Location</b></TableCell>
//                 <TableCell>Bengaluru</TableCell>
//                 <TableCell><b>PAN</b></TableCell>
//                 <TableCell>ABCDE1234F</TableCell>
//               </TableRow>
//               <TableRow>
//                 <TableCell><b>Bank Name</b></TableCell>
//                 <TableCell>HDFC Bank</TableCell>
//                 <TableCell><b>Account No</b></TableCell>
//                 <TableCell>XXXXXX9876</TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         {/* EARNINGS & DEDUCTIONS */}
//         <TableContainer component={Paper} className="table-box">
//           <Table size="small">
//             <TableBody>
//               <TableRow className="table-head">
//                 <TableCell>Earnings</TableCell>
//                 <TableCell>Amount (₹)</TableCell>
//                 <TableCell>Deductions</TableCell>
//                 <TableCell>Amount (₹)</TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell>Basic Salary</TableCell>
//                 <TableCell>43,333</TableCell>
//                 <TableCell>PF</TableCell>
//                 <TableCell>5,200</TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell>HRA</TableCell>
//                 <TableCell>17,333</TableCell>
//                 <TableCell>Income Tax</TableCell>
//                 <TableCell>16,589</TableCell>
//               </TableRow>

//               <TableRow>
//                 <TableCell>Special Allowance</TableCell>
//                 <TableCell>45,619</TableCell>
//                 <TableCell>Professional Tax</TableCell>
//                 <TableCell>200</TableCell>
//               </TableRow>

//               <TableRow className="total-row">
//                 <TableCell>Total Earnings</TableCell>
//                 <TableCell>1,06,285</TableCell>
//                 <TableCell>Total Deductions</TableCell>
//                 <TableCell>21,989</TableCell>
//               </TableRow>

//               <TableRow className="netpay-row">
//                 <TableCell colSpan={3}><b>Net Pay (In Words)</b></TableCell>
//                 <TableCell><b>₹ 84,296</b></TableCell>
//               </TableRow>
//             </TableBody>
//           </Table>
//         </TableContainer>

//         <Typography className="footer-note">
//           * This is a system generated payslip and does not require signature.
//         </Typography>
//       </Card>

//       {/* DOWNLOAD BUTTON */}
//       <Box textAlign="center" mt={3}>
//         <Button variant="contained" onClick={downloadPDF}>
//           Download Payslip PDF
//         </Button>
//       </Box>
//     </>
//   );
// };

// export default PaySlipTab;




import React, { useRef, useState } from "react";
import "./Payslip.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Box,
  Button,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Paper,
  TableContainer,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Divider,
} from "@mui/material";
import logo from "../../../assets/images/Picture2.png";

const PaySlipTab = () => {
  const pdfRef = useRef();
  const [year, setYear] = useState("2025");
  const [month, setMonth] = useState("August");

  const downloadPDF = async () => {
    const canvas = await html2canvas(pdfRef.current, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 190;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
    pdf.save(`Payslip_${month}_${year}.pdf`);
  };

  return (
    <>
      {/* FILTER */}
      <div className="payslip-filter">
        <FormControl size="small">
          <InputLabel>Year</InputLabel>
          <Select value={year} label="Year" onChange={(e) => setYear(e.target.value)}>
            {[2024, 2025, 2026].map((y) => (
              <MenuItem key={y} value={y}>{y}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small">
          <InputLabel>Month</InputLabel>
          <Select value={month} label="Month" onChange={(e) => setMonth(e.target.value)}>
            {["January","February","March","April","May","June","July","August"].map(m => (
              <MenuItem key={m} value={m}>{m}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* PAYSLIP */}
      <Card ref={pdfRef} className="payslip-wrapper">
        {/* HEADER */}
        <div className="payslip-header">
          <img src={logo} alt="logo" />
          <div>
            <h2>ENVISION INTEGRATED SERVICES PVT. LTD.</h2>
            <p>CIN: U72200TG2012PTC081093</p>
            <p>Hyderabad, Telangana</p>
          </div>
        </div>

        <Divider />

        <Typography className="payslip-title">
          Payslip for the Month of {month}, {year}
        </Typography>

        {/* EMP DETAILS */}
        <TableContainer component={Paper} className="table-box">
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell><b>Name</b></TableCell>
                <TableCell>Raja</TableCell>
                <TableCell><b>Employee ID</b></TableCell>
                <TableCell>EIS0785</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><b>Designation</b></TableCell>
                <TableCell>Junior Engineer</TableCell>
                <TableCell><b>Department</b></TableCell>
                <TableCell>IT</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><b>Bank</b></TableCell>
                <TableCell>Union Bank</TableCell>
                <TableCell><b>Account No</b></TableCell>
                <TableCell>XXXX52689</TableCell>
              </TableRow>
              <TableRow>
                <TableCell><b>Location</b></TableCell>
                <TableCell>Hyderabad</TableCell>
                <TableCell><b>PAN</b></TableCell>
                <TableCell>KWD**40063</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {/* SALARY */}
        <TableContainer component={Paper} className="table-box">
          <Table size="small">
            <TableBody>
              <TableRow className="table-head">
                <TableCell>Earnings</TableCell>
                <TableCell>₹</TableCell>
                <TableCell>Deductions</TableCell>
                <TableCell>₹</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Basic</TableCell><TableCell>5,334</TableCell>
                <TableCell>PF</TableCell><TableCell>640</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>HRA</TableCell><TableCell>2,133</TableCell>
                <TableCell>PT</TableCell><TableCell>200</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>Special Allowance</TableCell><TableCell>11,501</TableCell>
                <TableCell>Insurance</TableCell><TableCell>600</TableCell>
              </TableRow>

              <TableRow className="total-row">
                <TableCell>Total Earnings</TableCell><TableCell>25,718</TableCell>
                <TableCell>Total Deductions</TableCell><TableCell>3,440</TableCell>
              </TableRow>

              <TableRow className="netpay-row">
                <TableCell colSpan={3}><b>Net Pay</b></TableCell>
                <TableCell><b>₹ 22,278</b></TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <Typography className="footer-note">
          This is a system generated payslip and does not require signature.
        </Typography>
      </Card>

      <Box textAlign="center" mt={3}>
        <Button variant="contained" onClick={downloadPDF}>
          Download Payslip PDF
        </Button>
      </Box>
    </>
  );
};

export default PaySlipTab;

